import pro1 from '../src/Images/product-1.png'
import pro2 from '../src/Images/product-2.png'
import pro3 from '../src/Images/product-3.png'
import plus from '../src/Images/plus.jpg'
import { Link } from 'react-router-dom'
import Footer from './Footer'

const Product = () =>{
    return(
        <div>
        {/* // <!-- Start Product Section --> */}
		<div class="product-section">
			<div class="container ">
				<div class="row">

					{/* <!-- Start Column 1 --> */}
					<div class="col-md-12 col-lg-3 mb-5 mb-lg-0">
						<h2 class="mb-4 section-title">Crafted with excellent material.</h2>
						<p class="mb-4">Donec vitae odio quis nisl dapibus malesuada. Nullam ac aliquet velit. Aliquam vulputate velit imperdiet dolor tempor tristique. </p>
						<p><Link  to="#Product" class="btn">Explore</Link></p>
					</div> 
					{/* <!-- End Column 1 --> */}

					{/* <!-- Start Column 2 --> */}
					<div class="col-12 col-md-4 col-lg-3 mb-5 mb-md-0">
						<a class="product-item" href="cart.html">
							<img src={pro1} class="img-fluid product-thumbnail"/>
							<h3 class="product-title">Nordic Chair</h3>
							<strong class="product-price">$50.00</strong>

							<span class="icon-cross">
								<img src={plus} class="img-fluid"/>
							</span>
						</a>
					</div> 
					{/* <!-- End Column 2 --> */}

					{/* <!-- Start Column 3 --> */}
					<div class="col-12 col-md-4 col-lg-3 mb-5 mb-md-0">
						<a class="product-item" href="cart.html">
							<img src={pro2} class="img-fluid product-thumbnail"/>
							<h3 class="product-title">Kruzo Aero Chair</h3>
							<strong class="product-price">$78.00</strong>

							<span class="icon-cross">
								<img src={plus} class="img-fluid"/>
							</span>
						</a>
					</div>
					{/* <!-- End Column 3 --> */}

					{/* <!-- Start Column 4 --> */}
					<div class="col-12 col-md-4 col-lg-3 mb-5 mb-md-0">
						<a class="product-item" href="cart.html">
							<img src={pro3} class="img-fluid product-thumbnail"/>
							<h3 class="product-title">Ergonomic Chair</h3>
							<strong class="product-price">$43.00</strong>

							<span class="icon-cross">
								<img src={plus} class="img-fluid"/>
							</span>
						</a>
					</div>
					{/* <!-- End Column 4 --> */}

				</div>
			</div>
            {/* <!-- End Product Section --> */}
		</div>

		
        </div>
    )
}

export default Product;